import { Layout } from 'src/components/layout/layout';
import Component from 'src/components/ProductAssignment';

const ProductAssignment = () => {
    return (
        <Layout>
            <Component />
        </Layout>
    );
};

export default ProductAssignment;
